<script setup>
import { CANCEL_EDITION_MODE_EVENT, SAVE_EDITION_MODE_EVENT } from '@/plugins/utils/events.js'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

defineProps({
  showSave: {
    type: Boolean,
    default: true
  }
})

const cancelEdit = () => {
  const event = new CustomEvent(CANCEL_EDITION_MODE_EVENT);
  document.dispatchEvent(event);
}

const saveEdit = () => {
  const event = new CustomEvent(SAVE_EDITION_MODE_EVENT);
  document.dispatchEvent(event);
}

</script>

<template>
  <div class="edition-mode">
    <button class="cancel-btn" @click="cancelEdit">
      {{ t('cancel-edit') }}
    </button>
    <button v-if="showSave" class="save-btn" @click="saveEdit">
      <i class="icon-floppy" />{{ t('save-edit') }}
    </button>
  </div>
</template>

<i18n src="@/locales/editionMode.json"></i18n>